module.exports = __webpack_public_path__ + "static/media/img1.5588eec2.jpg";